import { render, staticRenderFns } from "./HighlightText.vue?vue&type=template&id=6e9ce37e&"
import script from "./HighlightText.vue?vue&type=script&lang=ts&"
export * from "./HighlightText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports